import { KEYS } from "../Keys";

export const GetTipsAndTricks = async (filter) => {
  const response = await fetch(
    KEYS.API + `/tip?type=${filter?.type ?? ""}&page=1&limit=100&sport=${filter?.sportName ?? ""}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("userToken")}`
      }
    }
  );
  return response;
};
